// language=GraphQL
export const ALL_TRAVEL_GUIDES_BLOCKS_QUERY = `query Query($withTravelGuides: Boolean = false, $withTravelGuidesImage: Boolean = false) {
  travelGuidesBlocks: cmsTravelGuidesBlocks {
    id
    travelGuides @include(if: $withTravelGuides) {
      id
      firstName
      lastName
      description
      image @include(if: $withTravelGuidesImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_TRAVEL_GUIDES_BLOCK_QUERY = `query Query($id: ID!, $withTravelGuides: Boolean = false, $withTravelGuidesImage: Boolean = false) {
  travelGuidesBlock: cmsTravelGuidesBlock(id: $id) {
    id
    travelGuides @include(if: $withTravelGuides) {
      id
      firstName
      lastName
      description
      image @include(if: $withTravelGuidesImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }
}`

// language=GraphQL
export const CREATE_TRAVEL_GUIDES_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsTravelGuidesBlockInput, $withTravelGuides: Boolean = false, $withTravelGuidesImage: Boolean = false) {
    travelGuidesBlock: createCmsTravelGuidesBlock(input: $input) {
      id
      travelGuides @include(if: $withTravelGuides) {
        id
        firstName
        lastName
        description
        image @include(if: $withTravelGuidesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_GUIDES_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsTravelGuidesBlockInput, $withTravelGuides: Boolean = false, $withTravelGuidesImage: Boolean = false) {
    travelGuidesBlock: updateCmsTravelGuidesBlock(input: $input) {
      id
      travelGuides @include(if: $withTravelGuides) {
        id
        firstName
        lastName
        description
        image @include(if: $withTravelGuidesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_GUIDES_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsTravelGuidesBlockInput) {
    deleteCmsTravelGuidesBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_TRAVEL_GUIDES_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsTravelGuidesBlockInput) {
    forceDeleteCmsTravelGuidesBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_TRAVEL_GUIDES_BLOCK_TRAVEL_GUIDES_MUTATION = `
  mutation Mutation($input: addCmsTravelGuidesBlockTravelGuidesInput) {
    addCmsTravelGuidesBlockTravelGuides(input: $input) {
      id
      travelGuideIds
    }
  }`

// language=GraphQL
export const REMOVE_TRAVEL_GUIDES_BLOCK_TRAVEL_GUIDES_MUTATION = `
  mutation Mutation($input: removeCmsTravelGuidesBlockTravelGuidesInput) {
    removeCmsTravelGuidesBlockTravelGuides(input: $input) {
      id
      travelGuideIds
    }
  }`

// language=GraphQL
export const CREATE_TRAVEL_GUIDES_BLOCK_TRAVEL_GUIDES_MUTATION = `
  mutation Mutation($input: createCmsTravelGuidesBlockTravelGuidesInput) {
    createCmsTravelGuidesBlockTravelGuides(input: $input) {
      id
      travelGuideIds
    }
  }`

// language=GraphQL
export const DELETE_TRAVEL_GUIDES_BLOCK_TRAVEL_GUIDES_MUTATION = `
  mutation Mutation($input: deleteCmsTravelGuidesBlockTravelGuidesInput) {
    deleteCmsTravelGuidesBlockTravelGuides(input: $input) {
      id
      travelGuideIds
    }
  }`

// language=GraphQL
export const UPDATE_TRAVEL_GUIDES_BLOCK_TRAVEL_GUIDES_ORDER_MUTATION = `
  mutation Mutation($input: updateCmsTravelGuidesBlockTravelGuidesOrderInput) {
    updateCmsTravelGuidesBlockTravelGuidesOrder(input: $input) {
      id
      travelGuideIds
    }
  }`
